import React, { useState } from 'react';
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import CreateInvoiceTableData from './CreateInvoiceTableData';
import QuickCustomerModal from '../../../Utils/QuickCustomerModal';
import FormInputs from '../../../Utils/FormInputs';
// icon
import { mdiPlus } from '@mdi/js';

export default function CreateInvoice() {
    // Add Customer modal
    const [customerModalShow, setCustomerModalShow] = useState(false);
    const handleShowCustomer = () => setCustomerModalShow(true);
    const handleCloseCustomer = () => setCustomerModalShow(false);

    const initialInputData = {
        customer_name: '',
        mobile_number: '',
        challan_date: '',
        service_category: '',
        services: '',
        provider_service: '',
        campaign: '',
        product_category: '',
        quote_product: '',
        provider_membership: '',
        current_stock: '',
        quantity: '',
        memberships: '',
        start_date: '',
        product_provider: '',
    }

    const [inputData, setInputData] = useState(initialInputData);
    const handleSalesViewInvoiceChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleSalesViewInvoiceSubmit = (e) => {
        e.preventDefault();
    };
    const salesViewInvoicerows = [
        {
            columns: [
                { size: { xl: 4 }, label: 'Customer Name', type: 'inputwithbtn', placeholder: 'Enter customer name...', name: 'customer_name', id: 'customerName', value: inputData.customer_name, handleOnClick: handleShowCustomer, errormsg: '', },
                { size: { sm: 6, xl: 4 }, label: 'Mobile Number', type: 'number', placeholder: '(+001) 1234 5678 90', name: 'mobile_number', id: 'mobileNumber', value: inputData.mobile_number, errormsg: '', },
                { size: { sm: 6, xl: 4 }, label: 'Challan Date', type: 'date', placeholder: 'DD/MM/YYYY', name: 'challan_date', id: 'challanDate', value: inputData.challan_date, errormsg: '', },
            ]
        },
    ];
    const salesViewInvoiceButtons = [];

    // Sales ViewInvoice Service Form
    const handleSViewInvoiceServiceChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleSCViewInvoiceServiceSubmit = (e) => {
        e.preventDefault();
    };
    const sViewInvoiceServiceRows = [
        {
            rowClass: 'align-items-end',
            columns: [
                {
                    size: { sm: 6, xl: 3 }, label: 'Service Category', type: 'select', name: 'service_category', id: 'serviceCategory', value: inputData.service_category, errormsg: '',
                    options: [
                        { value: '', label: 'All' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { sm: 6, xl: 2 }, label: 'Service', type: 'select', name: 'services', id: 'services', value: inputData.services, errormsg: '',
                    options: [
                        { value: '', label: 'Select Service' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { sm: 6, xl: 3 }, label: 'Provider', type: 'multiSelect', isMulti: 'true', placeholder: 'Select provider...1', name: 'provider_service', id: 'providerService', value: inputData.provider_service, errormsg: '',
                    options: [
                        { value: "Test", label: "Test" },
                        { value: "Umesh bhai", label: "Umesh bhai" },
                        { value: "NSF Adajan", label: "NSF Adajan" },
                        { value: "NFS Parle Point", label: "NFS Parle Point" },
                        { value: "NFS Uniform", label: "NFS Uniform" },
                    ],
                },
                {
                    size: { sm: 6, xl: 3 }, label: 'Campaign', type: 'select', name: 'campaign', id: 'campaign', value: inputData.campaign, errormsg: '',
                    options: [
                        { value: '', label: 'Select Campaign' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { xl: 1 }, type: 'button', additionalClass: 'justify-content-end mb-3',
                    buttons: [
                        { color: 'primary', icon: mdiPlus, id: 'addProduct', text: 'Add', additionalClass: 'btn-w-lg', },
                    ]
                },
            ]
        },
    ];
    const sViewInvoiceServiceButtons = [];

    // Sales ViewInvoice Product Form
    const handleSViewInvoiceProductChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleSViewInvoiceProductSubmit = (e) => {
        e.preventDefault();
    };
    const sViewInvoiceProductRows = [
        {
            rowClass: 'align-items-end',
            columns: [
                {
                    size: { sm: 6, md: 4, xxl: 2 }, label: 'Product Category', type: 'select', name: 'product_category', id: 'productCategory', value: inputData.product_category, errormsg: '',
                    options: [
                        { value: '', label: 'All' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                { size: { sm: 6, md: 4, xxl: 3 }, label: 'Product', type: 'text', placeholder: 'Enter product...', name: 'quote_product', id: 'quoteProduct', value: inputData.quote_product, errormsg: '', },
                {
                    size: { sm: 6, md: 4, xxl: 2 }, label: 'Provider', type: 'multiSelect', isMulti: 'true', placeholder: 'Select provider...', name: 'provider_membership', id: 'providerMembership', value: inputData.provider_membership, errormsg: '',
                    options: [
                        { value: "Test", label: "Test" },
                        { value: "Umesh bhai", label: "Umesh bhai" },
                        { value: "NSF Adajan", label: "NSF Adajan" },
                        { value: "NFS Parle Point", label: "NFS Parle Point" },
                        { value: "NFS Uniform", label: "NFS Uniform" },
                    ],
                },
                { size: { sm: 6, md: 4, xxl: 2 }, label: 'Current Stock', type: 'text', placeholder: 'Enter current stock...', name: 'current_stock', id: 'currentStock', value: inputData.current_stock, errormsg: '', },
                { size: { sm: 6, md: 4, xxl: 2 }, label: 'Quantity', type: 'text', placeholder: 'Enter quantity...', name: 'quantity', id: 'quantity', value: inputData.quantity, errormsg: '', },
                {
                    size: { sm: 6, md: 4, xxl: 1 }, type: 'button', additionalClass: 'justify-content-end mb-3',
                    buttons: [
                        { color: 'primary', icon: mdiPlus, id: 'addProduct', text: 'Add', additionalClass: 'btn-w-lg', },
                    ]
                },
            ]
        },
    ];
    const sViewInvoiceProductButtons = [];

    // Sales ViewInvoice Membership Form
    const handleSViewInvoiceMembershipChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleSViewInvoiceMembershipSubmit = (e) => {
        e.preventDefault();
    };
    const sViewInvoiceMembershipRows = [
        {
            rowClass: 'align-items-end',
            columns: [
                {
                    size: { sm: 6, lg: 3, xl: 4 }, label: 'Memberships', type: 'select', name: 'memberships', id: 'memberships', value: inputData.memberships, errormsg: '',
                    options: [
                        { value: '', label: 'Select' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                { size: { sm: 6, lg: 3, xl: 3 }, label: 'Start Date', type: 'date', placeholder: 'DD/MM/YYYY', name: 'start_date', id: 'startDate', value: inputData.start_date, errormsg: '', },
                {
                    size: { sm: 6, lg: 4, xl: 4 }, label: 'Provider', type: 'multiSelect', isMulti: 'true', placeholder: 'Select provider...', name: 'product_provider', id: 'productProvider', value: inputData.product_provider, errormsg: '',
                    options: [
                        { value: "Test", label: "Test" },
                        { value: "Umesh bhai", label: "Umesh bhai" },
                        { value: "NSF Adajan", label: "NSF Adajan" },
                        { value: "NFS Parle Point", label: "NFS Parle Point" },
                        { value: "NFS Uniform", label: "NFS Uniform" },
                    ],
                },
                {
                    size: { sm: 6, lg: 2, xl: 1 }, type: 'button', additionalClass: 'justify-content-end mb-3',
                    buttons: [
                        { color: 'primary', icon: mdiPlus, id: 'addProduct', text: 'Add', additionalClass: 'btn-w-lg', },
                    ]
                },
            ]
        },
    ];
    const sViewInvoiceMembershipButtons = [];

    return (
        <>
            <Card>
                <Card.Body className='pb-0'>
                    <FormInputs Buttons={salesViewInvoiceButtons} rows={salesViewInvoicerows} handleInputChange={handleSalesViewInvoiceChange} handleSubmit={handleSalesViewInvoiceSubmit} />

                    <Row>
                        <Col md={6} xl={4}>
                            <h5 className='fs-16 mb-3'>GST No :</h5>
                        </Col>
                        <Col md={6} xl={4}>
                            <h5 className='fs-16 mb-3'>Advance Payment : <span className='fw-normal'>0₹</span></h5>
                        </Col>
                        <Col md={6} xl={4}>
                            <h5 className='fs-16 mb-3'>Membership : <span className='fw-normal'>0</span></h5>
                        </Col>
                        <Col md={6} xl={4}>
                            <h5 className='fs-16 mb-3'>Notes :</h5>
                        </Col>
                        <Col md={6} xl={4}>
                            <h5 className='fs-16 mb-3'>Wallet Balance : <span className='fw-normal'>0₹</span></h5>
                        </Col>
                        <Col md={6} xl={4}>
                            <h5 className='fs-16 mb-3'>Membership Credit Balance : <span className='fw-normal'>0₹</span></h5>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <Card>
                <Card.Body>
                    <div className="tab-content custom-top-nav-tab" id="pills-tabContent">
                        <div className="tab-pane fade show active" id="pills-view-vendor" role="tabpanel" aria-labelledby="pills-view-vendor-tab" tabIndex="0">
                            <ul className="nav nav-pills nav-fill btn-list mb-3" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="pills-service-tab" data-bs-toggle="pill" data-bs-target="#pills-service" type="button" role="tab" aria-controls="pills-service" aria-selected="true">Service</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-product-tab" data-bs-toggle="pill" data-bs-target="#pills-product" type="button" role="tab" aria-controls="pills-product" aria-selected="false">Product</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-membership-tab" data-bs-toggle="pill" data-bs-target="#pills-membership" type="button" role="tab" aria-controls="pills-membership" aria-selected="false">Membership</button>
                                </li>
                            </ul>

                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-service" role="tabpanel" aria-labelledby="pills-service-tab" tabIndex="0">
                                    <FormInputs Buttons={sViewInvoiceServiceButtons} rows={sViewInvoiceServiceRows} handleInputChange={handleSViewInvoiceServiceChange} handleSubmit={handleSCViewInvoiceServiceSubmit} />
                                </div>
                                <div className="tab-pane fade" id="pills-product" role="tabpanel" aria-labelledby="pills-product-tab" tabIndex="0">
                                    <FormInputs Buttons={sViewInvoiceProductButtons} rows={sViewInvoiceProductRows} handleInputChange={handleSViewInvoiceProductChange} handleSubmit={handleSViewInvoiceProductSubmit} />
                                </div>
                                <div className="tab-pane fade" id="pills-membership" role="tabpanel" aria-labelledby="pills-membership-tab" tabIndex="0">
                                    <FormInputs Buttons={sViewInvoiceMembershipButtons} rows={sViewInvoiceMembershipRows} handleInputChange={handleSViewInvoiceMembershipChange} handleSubmit={handleSViewInvoiceMembershipSubmit} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <CreateInvoiceTableData />
                </Card.Body>
            </Card>

            <Card>
                <Card.Body>
                    <Row>
                        <Col md={6}>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Sub Total</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Control type="text" name='subTotal' id='subTotal' size='sm' readOnly />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Total Item Discount</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Control type="text" name='totalItemDiscount' id='totalItemDiscount' size='sm' readOnly />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Discount</Form.Label>
                                <Col xs={8} sm={6} md={4} lg={5} xxl={7}>
                                    <Form.Control type="text" name='discount' id='discount' size='sm' readOnly />
                                </Col>
                                <Col xs={4} sm={3} md={3} lg={3} xxl={2}>
                                    <Form.Select size='sm' id='discountSelect'>
                                        <option>% Off</option>
                                        <option value="1">Rs. Off</option>
                                    </Form.Select>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Campaign</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Select size='sm' id='campaignSelect'>
                                        <option>Nothing selected</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                    </Form.Select>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Loyalty</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Select size='sm' id='LoyaltySelect'>
                                        <option>Nothing selected</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                    </Form.Select>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Loyalty Amount</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Control type="text" name='loyaltyAmount' id='loyaltyAmount' size='sm' readOnly />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Taxable Amount</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Control type="text" name='taxableAmount' id='taxableAmount' size='sm' readOnly />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>CGST</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Control type="text" name='cGst' id='cGst' size='sm' readOnly />
                                </Col>
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>SGST</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Control type="text" name='sGst' id='sGst' size='sm' readOnly />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Total Tax Amount</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Control type="text" name='totalTaxAmount' id='totalTaxAmount' size='sm' readOnly />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Advance Payment</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Control type="text" name='totalTaxAmount' id='totalTaxAmount' size='sm' readOnly />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Advance Payment Amount</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Control type="text" name='totalTaxAmount' id='totalTaxAmount' size='sm' readOnly />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Grand Total</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Control type="text" name='totalTaxAmount' id='totalTaxAmount' size='sm' readOnly />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Payment Type</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Select size='sm' id='campaignSelect'>
                                        <option>Cash</option>
                                        <option value="1">Bank</option>
                                        <option value="2">Online</option>
                                    </Form.Select>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Amount Received</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Control type="text" name='grandTotal' id='grandTotal' size='sm' readOnly />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Amount Due</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Control type="text" name='grandTotal' id='grandTotal' size='sm' readOnly />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className='py-0 mb-2 mb-sm-0' column sm={3} md={5} lg={4} xxl={3}>Amount Repaid</Form.Label>
                                <Col sm={9} md={7} lg={8} xxl={9}>
                                    <Form.Control type="text" name='grandTotal' id='grandTotal' size='sm' readOnly />
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='align-items-end'>
                        <Col xl={5} xxl={6}>
                            <div className="mb-3 mb-xl-0 custom-form-input custom-form-input-sm">
                                <Form.Label>Narration</Form.Label>
                                <Form.Control type="text" name='narration' id='narration' placeholder='Enter Narration' />
                            </div>
                        </Col>
                        <Col xl={7} xxl={6} className='text-end'>
                            <div className="btn-list">
                                <Button variant="primary">Generate and Print</Button>{' '}
                                <Button variant="success">Generate and New</Button>{' '}
                                <Button variant="info">Generate Invoice</Button>{' '}
                                <Button variant="warning">Print Option</Button>{' '}
                                <Button variant="secondary">Cancel</Button>{' '}
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Add Customer modal */}
            <QuickCustomerModal addCustomerShow={customerModalShow} addCustomerClose={handleCloseCustomer} />
        </>
    )
}
